import { ERROR, READY, useVisualState } from '../../../hooks/useVisualState'
import { Form, FormBand } from '../../../components/Form/Form'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { oldGet, oldPost } from '../../../helpers/requestOld'

import Button from '../../../components/Button/Button'
import GenericErrorModal from '../../../modules/GenericErrorModal/GenericErrorModal'
import Modal from '../../../components/Modal/Modal'
import ModalContent from '../../../components/Modal/ModalContent'
import ModalFooter from '../../../components/Modal/ModalFooter'
import ModalHeader from '../../../components/Modal/ModalHeader'
import PhotoUploader from '../../../components/PhotoUploader/PhotoUploader'
import ProgressBar from '../../../components/ProgressBar/ProgressBar'
import Select from '../../../components/Select/Select'
import SelectItem from '../../../components/Select/SelectItem'
import { TECHNICAL_STAFF_NAMES } from '../../../helpers/constants'
import TextField from '../../../components/TextField/TextField'
import { closeEvent } from '../../../components/Modal/ModalEvents'
import t from '../../../helpers/i18n'
import { uploadFileHelper } from '../../../helpers/upload'
import useForceUpdate from '../../../hooks/useForceUpdate'
import useObjectState from '../../../hooks/useObjectState'
import { useParams } from 'react-router-dom'

const emailValidation = (text) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(text) ? false : t('validations.invalid_email')
const phoneValidation = (text) => /^.{1,20}$/.test(text) ? false : t('validations.phone_number_is_invalid')

const OldTechnicalStaffFormModal = ({ onCloseRequested }) => {
  const [formValid, setFormValid] = useState(false)
  const [uploading, setUploading] = useObjectState()
  const [error, setError] = useState()
  const createTechnicalStaffData = useRef()
  const createTechnicalStaffPending = useRef()
  const formModal = useRef()
  const uploadModal = useRef()
  const cancel = useRef(false)
  const [[technicalStaffState, technicalStaff], setTechnicalStaff] = useVisualState()
  const { teamId, technicalStaffId } = useParams()
  const [, forceUpdate] = useForceUpdate()
  const isNew = technicalStaffId === 'new'

  const handleSavePlayer = useCallback(() => {
    uploadFileHelper(createTechnicalStaffPending.current, { avatar: 'avatar' }, setUploading)
      .then(data => {
        if (!cancel.current) {
          oldPost('/delegate/teams/' + teamId + '/technical_staff/' + technicalStaffId, { ...createTechnicalStaffData.current, ...data })
            .then(() => closeEvent(formModal.current, true))
            .catch(error => {
              setError(error)
            })
        }
      })

  }, [teamId, technicalStaffId, setUploading])

  const handleCancelUpload = useCallback(() => {
    cancel.current = true
    closeEvent(uploadModal.current, false)
  }, [])

  useEffect(() => {
    if (isNew) {
      setTechnicalStaff(READY, {})
    } else {
      oldGet('/delegate/teams/' + teamId + '/technical_staff/' + technicalStaffId)
        .then(response => setTechnicalStaff(READY, response))
        .catch(error => setTechnicalStaff(ERROR, error))
    }
  }, [setTechnicalStaff, teamId, technicalStaffId, isNew])

  return (
    <div>
      {technicalStaffState === READY &&
        <Modal onCloseRequested={onCloseRequested} elementRef={formModal}>
          <ModalHeader title={isNew ? t('modal_headers.Add_new_technical_staff') : t('modal_headers.Edit_technical_staff')} />
          <Form data={createTechnicalStaffData} pending={createTechnicalStaffPending} onValidityChange={setFormValid} onChange={forceUpdate}>
            <ModalContent>
              <FormBand text={t("titles.Personal_Information")} />
              <div className="-layout-21">
                <div>
                  <TextField
                    name="first_name"
                    label={t('labels.First_Name')}
                    mode="entity-name"
                    maxLength={100}
                    minLength={2}
                    required
                    initialValue={technicalStaff.first_name}
                  />
                  <TextField
                    name="last_name"
                    label={t('labels.Last_Name')}
                    mode="entity-name"
                    maxLength={100}
                    minLength={2}
                    required
                    initialValue={technicalStaff.last_name}
                  />
                </div>
                <div>
                  <PhotoUploader
                    name="avatar"
                    label={t('labels.Pic')}
                    aspect={1}
                    source={technicalStaff.avatar}
                    circular
                  />
                </div>
              </div>
              <Select
                  name="role"
                  label={t("labels.Role")}
                  initialValue={technicalStaff.role}
                  required
              >
                <SelectItem></SelectItem>
                {TECHNICAL_STAFF_NAMES.map(technical_staff_id =>
                  <SelectItem key={technical_staff_id} value={technical_staff_id}>{t("roles.technical_staff." + technical_staff_id)}</SelectItem>
                )}
              </Select>
            </ModalContent>
            <ModalContent>
              <FormBand text={t("titles.Contact")} />
              <TextField
                name="email"
                label={t('labels.Email')}
                onValidation={emailValidation}
                initialValue={technicalStaff.email}
                />
              <TextField
                name="phone"
                label={t('labels.Contact_phone')}
                onValidation={phoneValidation}
                maxLength={50}
                initialValue={technicalStaff.phone}
                />
            </ModalContent>
          </Form>
          <ModalFooter>
            <div>
              <Button onClick={event => closeEvent(event.currentTarget, false)} label={t("buttons.Cancel")} />
            </div>
            <div>
              <Button disabled={!formValid} onClick={handleSavePlayer} label={t("buttons.Save")} />
            </div>
          </ModalFooter>
          {uploading &&
            <Modal elementRef={uploadModal} onCloseRequested={handleCancelUpload}>
              <ModalHeader title={t("modal_headers.Uploading_files")} back={false} />
              <ModalContent dialog>
                {Object.keys(uploading).map(key =>
                  <div key={key}>
                    <div className="text-label color-text">{FILE_NAMES[key] || createTechnicalStaffPending.current[key].value.name}</div>
                    <ProgressBar percent={uploading[key]} />
                  </div>
                )}
              </ModalContent>
            </Modal>
          }
          {error && <GenericErrorModal error={error} i18nPrefix="OldTechnicalStaffFormModal" onCloseRequested={() => setError(false)} />}
        </Modal>
      }
    </div>
  )
}

const FILE_NAMES = {
  "avatar": "Foto del cuerpo técnico",
}

export default OldTechnicalStaffFormModal